import { useIntl } from "react-intl";

// "Lebenslauf.pdf" → ["Lebenslauf", ".pdf"]; names without an extension
// (e.g. CV drafts) edit in full.
function splitFileExt(name: string): [string, string] {
  const m = name.match(/\.[a-z0-9]{2,8}$/i);
  return m ? [name.slice(0, -m[0].length), m[0]] : [name, ""];
}

// Rename input that keeps the file extension fixed - only the stem is
// editable, the extension renders as a non-editable suffix.
export function ExtRenameInput({
  id,
  name,
  onRename,
  onBlur,
  autoFocus,
  className,
}: {
  id?: string;
  name: string;
  onRename: (newName: string) => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  className: string;
}) {
  const [stem, ext] = splitFileExt(name);
  const intl = useIntl();
  return (
    <span className="flex min-w-0 flex-1 items-center gap-0.5">
      <input
        id={id}
        value={stem}
        onChange={(e) => onRename(e.target.value + ext)}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === "Escape") e.currentTarget.blur();
        }}
        autoFocus={autoFocus}
        aria-label={intl.formatMessage({ id: "service.extRename.ariaLabel", defaultMessage: "Rename" })}
        className={className}
      />
      {ext ? <span className="shrink-0 text-smycles-label text-ink">{ext}</span> : null}
    </span>
  );
}
